import Utils from "@/components/shared/util";
import GraphRanges from "@/mixins/GraphRanges";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { Atom } from "@/store/types";
import _ from "lodash";
import { mixins } from "vue-class-component";
import { Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { MultiChartConfig } from "../shared/chart/MultiChartWithSharedRange";

@Component({})
export default class Icp extends mixins(GraphRanges) {
  @Getter("graph", patientNamespace)
  graph!: Function;

  @Getter("atomList", patientNamespace)
  atomList!: any;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("current", patientNamespace)
  current!: Patient;

  get tableData() {
    if (!this.current || !this.current.body) {
      return [];
    }
    const mappingConfig = [
      { key: "atoms.icp", label: "ICP" },
      { key: "atoms.cpp", label: "CPP" },
      { key: "atoms.sodium", label: "Sodium" },
      { key: "monitor.EndTidalCO2", label: "EndTidal CO<sub>2</sub>" }
    ];
    const output = mappingConfig.map(config => {
      const atom = _.get(this.current.body, config.key) as Atom;

      const value = atom && atom.age >= 0 ? atom.value : "N/A";

      const age = atom && atom.age >= 0 ? atom.age : "N/A";

      const color =
        atom && atom.level !== 3 ? Utils.getLevelTableColor(atom.level) : "";

      return { label: config.label, value, age, color };
    });

    return output;
  }

  chartLabels = ["ICP", "CPP"];

  get medianDisclaimer() {
    const median: string = _.get(this, "atomList['icp'].trend", "15");
    return (
      "*Data points displayed for " +
      this.chartLabels.join(" & ") +
      " represent the median over " +
      median +
      " minutes, saved to the graph every 15 minutes."
    );
  }

  get charts(): MultiChartConfig[] {
    return [
      {
        title: "Median " + this.chartLabels.join(" & ") + "*",
        data: this.graph(this.chartLabels),
        suggestedMin: -10,
        suggestedMax: 120
      }
    ];
  }
}
